import React, {Fragment,useEffect, useState} from 'react';
import PageWrapper from "../../components/PageWrapper";
import PageHeader from "../../components/PageHeader";
import BlogsContent from "./BlogsContent";
import SidebarForBlog from './../SidebarForBlog/index';
import { useBlogPageHeader } from './../../queries/blogPageHeader';
import { useParams, useNavigate } from 'react-router-dom';
import ToolBarMenu from '../../components/ToolBarMenu';
import InfinitProgressBar from '../../components/InfiniteProgressBar';
const BlogPage = ({sidebar_position,blog_type,sidebar}) => {
    const navigate  = useNavigate ();
    const urlData = useParams();
    const [blogPagination, setBlogPagination] = useState({
        searchText: urlData.searchText,
        blogs: [],
        currentPage: +(urlData.page),
        blogsPerPage: 6
    });
    const [currentPage, setCurrentPage] = useState(+(urlData.page));
    const [searchPhrase, setSearchPhrase] = useState(urlData.searchText ? urlData.searchText : '');
    const blogsPage = useBlogPageHeader();
    useEffect(() => {
       
        navigate(`/blogs/${currentPage}${blogPagination.searchText ? `/${searchPhrase ? searchPhrase : 'null'}` : ''}`)
    }, [currentPage, blogPagination])
    if(blogsPage.loading) return <InfinitProgressBar/>
    if(blogsPage.error) return <div>error!</div>
    return (
        <Fragment>
           <PageHeader
                bgImg={blogsPage.data.blogPageHeader[0].blogPageHeaderImage.urls[0]}
                title={blogsPage.data.blogPageHeader[0].displayText}
                content={blogsPage.data.blogPageHeader[0].blogPageHeaderSubtitle.html}
            />
            <PageWrapper classes={'blog-page-content-area sp-y'}>
                {sidebar === true && sidebar_position === 'left' ? <SidebarForBlog blogPagination={blogPagination} searchPhrase={searchPhrase} searchPhraseSetter={setSearchPhrase} currentPageSetter={setCurrentPage} currentPage={currentPage} blogPaginationSetter={setBlogPagination}  classes={'order-1 order-lg-0'}  /> : null}
                  
                 {
                  blogPagination.blogs && blogPagination.blogs.length > 0 ? 
                    <BlogsContent blogPagination={blogPagination} blogPaginationSetter={setBlogPagination} currentPageSetter={setCurrentPage}  blog_type={blog_type} cols={sidebar ? 'col-lg-8' : 'col-12'} classes={sidebar_position === 'left' ? 'order-0 order-lg-1':null}/>  : <div>موردی یافت نشد</div>}
                
                {sidebar === true && sidebar_position === 'right' ? <SidebarForBlog/> : null}
            </PageWrapper>
        </Fragment>
    );
};

export default BlogPage;




// import React from 'react';
// import PageWrapper from '../../components/PageWrapper/index';
// import ToolBarMenu from '../../components/ToolBarMenu/index';
// import Header from '../../components/Header/index';
// import PageHeader from '../../components/PageHeader/index';

// import Footer from '../../components/Footer/index';
// import { useBlog } from './../../queries/blog';
// import BlogsContent from './BlogsContent';


// const Blogs = () => {


//     const {data, error, loading} = useBlog()
//     if(error) return <div>error!</div>
//     if(loading) return <InfinitProgressBar/>


//     return (  
//         <PageWrapper>
//             <div className="col-12">

//                 {/* <ToolBarMenu/> */}

//                 <Header/>

//                 <PageHeader
//                     bgImg={require('../../assets/img/page-header.jpg')}
//                     title={'وبلاگ'}
//                     content={''}
//                 />
//                 <br/>
//                 <BlogsContent data={data} />
//                 <br/>            
//                 <br/>
//                 <br/>

//                 <Footer/>

//             </div>
//         </PageWrapper>
//     );
// }
 
// export default Blogs;